import { useMemo, useRef } from 'react'

const emptyArr = [] as ReadonlyArray<never>

type HasId = {
  id: string
}

export function useCachedItems<T extends HasId>(
  ids: ReadonlyArray<string> = emptyArr,
  pageItems: ReadonlyArray<T> = emptyArr,
) {
  const cacheRef = useRef(new Map<string, T>())

  const result = useMemo(() => {
    for (const item of pageItems) {
      cacheRef.current.set(item.id, item)
    }

    const idsSet = new Set(ids)

    for (const id of cacheRef.current.keys()) {
      if (!idsSet.has(id)) {
        cacheRef.current.delete(id)
      }
    }

    const items: Array<T> = []
    for (const id of ids) {
      const item = cacheRef.current.get(id)
      if (item) {
        items.push(item)
      }
    }
    return { items, has: (id: string) => cacheRef.current.has(id) }
  }, [ids, pageItems])

  return result
}
